var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#11B50C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0531 8.28037C18.6601 7.88739 18.127 7.66663 17.5712 7.66663C17.0153 7.66663 16.4823 7.88739 16.0892 8.28037L8.67711 15.6934C8.46095 15.9094 8.31181 16.1832 8.24763 16.482L7.67628 19.1479C7.66121 19.2179 7.66393 19.2905 7.68418 19.3592C7.70444 19.4279 7.74158 19.4905 7.79223 19.5411C7.84287 19.5917 7.90539 19.6289 7.97409 19.6491C8.04279 19.6694 8.11546 19.6721 8.18548 19.657L10.8515 19.0857C11.1503 19.0215 11.4241 18.8724 11.6402 18.6563L19.0531 11.2437C19.446 10.8507 19.6667 10.3177 19.6667 9.76203C19.6667 9.20634 19.446 8.67339 19.0531 8.28037ZM16.6957 8.88641C16.9301 8.66478 17.2417 8.54332 17.5642 8.54784C17.8867 8.55236 18.1948 8.68251 18.4228 8.91061C18.6509 9.13872 18.781 9.44678 18.7854 9.7693C18.7899 10.0918 18.6683 10.4034 18.4466 10.6377L18.0609 11.0234L16.3095 9.27257L16.6957 8.88641ZM15.703 9.87861L17.4544 11.6299L11.0345 18.0507C10.9352 18.1499 10.8092 18.2184 10.6719 18.2478L8.65267 18.6807L9.08558 16.662C9.11498 16.5247 9.18345 16.3987 9.28274 16.2994L15.703 9.87861Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.d78b4d4fd1a948a36202f90391c231a5.svg";
export { ForwardRef as ReactComponent };